type Props = { value: string };

export function TranslatedHeader({ value }: Props) {
  const parts = value.split("|");
  if (parts.length === 1) return <>{value}</>;
  return <>{parts[0]}<br />{parts.slice(1).join(" ")}</>;
}
